import QuantityDisclaimerComponente from "./QuantityDisclaimer.Component";

export default QuantityDisclaimerComponente;
